import { render } from "./media-control-play.svg?vue&type=template&id=cea683f6"
const script = {}
script.render = render

export default script